import { render, staticRenderFns } from "./ListaSelosCancelados.vue?vue&type=template&id=73e61926&"
import script from "./ListaSelosCancelados.vue?vue&type=script&lang=js&"
export * from "./ListaSelosCancelados.vue?vue&type=script&lang=js&"
import style0 from "./ListaSelosCancelados.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports